import { useEffect, useState } from "react";
import { makeRequestAuth } from "../../_config/api";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import { FaCog, FaSearch, FaClock, FaWallet, FaTimes, FaArrowRight, FaCheck, FaArrowLeft, FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import { HiOutlineCurrencyRupee } from "react-icons/hi";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";


const timeSlotsList = [
    "7:30 to 9:30 AM",
    "9:30 to 11:30 AM",
    "11:30am to 1:30 pm",
    "2:00 pm to 4:00 pm",
    "4:00 pm to 6:00 pm",
    "6:00 pm to 8:00 PM"
];

export default function ServiceSetting() {
    const navigate = useNavigate()
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [limit] = useState(12);
    const [search, setSearch] = useState("");
    // ⏰ Dynamic Slots & Edit States
    const [allSlots, setAllSlots] = useState(timeSlotsList);
    const [newSlotText, setNewSlotText] = useState("");
    const [editingSlot, setEditingSlot] = useState(null); // { oldText: "", newText: "" }

    // Naya Slot Add Karne Ka Function
    const handleAddCustomSlot = () => {
        if (!newSlotText.trim()) return;
        const trimmed = newSlotText.trim();
        if (!allSlots.includes(trimmed)) {
            setAllSlots(prev => [...prev, trimmed]);
        }
        // Naye slot ko automatically select kar lein
        setSettingsData(prev => {
            const currentSlots = Array.isArray(prev.slots) ? prev.slots : [];
            if (!currentSlots.some(s => s.timeSlot === trimmed)) {
                return {
                    ...prev,
                    slots: [...currentSlots, { timeSlot: trimmed, slotCount: 1 }]
                };
            }
            return prev;
        });
        setNewSlotText("");
    };

    // Slot Edit Karke Save Karne Ka Function
    const handleSaveEdit = () => {
        if (!editingSlot || !editingSlot.newText.trim()) return;
        const oldText = editingSlot.oldText;
        const newText = editingSlot.newText.trim();

        setAllSlots(prev => prev.map(s => s === oldText ? newText : s));
        setSettingsData(prev => ({
            ...prev,
            slots: (prev.slots || []).map(s => s.timeSlot === oldText ? { ...s, timeSlot: newText } : s)
        }));
        setEditingSlot(null);
    };

    // Slot Delete Karne Ka Function
    const handleDeleteSlot = (e, slot) => {
        e.stopPropagation();
        setAllSlots(prev => prev.filter(s => s !== slot));
        setSettingsData(prev => ({
            ...prev,
            slots: (prev.slots || []).filter(s => s.timeSlot !== slot)
        }));
    };

    const [showPriceModal, setShowPriceModal] = useState(false);
    const [showSettingsModal, setShowSettingsModal] = useState(false);
    const [priceData, setPriceData] = useState({ id: null, amount: "", name: "" });
    const [settingsData, setSettingsData] = useState({ id: null, name: "", slots: [] });

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await makeRequestAuth("post", "/admin/getListServiceCategory", {
                pageNo: page, size: limit, search, status: 'Active',
            });
            if (res?.error) {
                showErrorToast(res.message || "Failed to fetch");
                return;
            }
            setServices(res?.data?.list || []);
        } catch (error) {
            showErrorToast("Connection Error!");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchData(); }, [page, search]);

    const toggleSlotSelection = (timeSlot) => {
        setSettingsData(prev => {
            const exists = prev.slots.find(s => s.timeSlot === timeSlot);
            if (exists) {
                // Remove if already exists (Deselect)
                return { ...prev, slots: prev.slots.filter(s => s.timeSlot !== timeSlot) };
            } else {
                // Add new object with default count 1 (Select)
                return { ...prev, slots: [...prev.slots, { timeSlot, slotCount: 1 }] };
            }
        });
    };

    const handleSaveSettings = async () => {
        try {
            const payload = {
                id: settingsData.id,
                slots: settingsData.slots
            };

            const res = await makeRequestAuth(
                "post",
                "/admin/serviceCategorySlotsSetting",
                payload
            );

            if (res?.error) {
                showErrorToast(res.message || "Failed to update slots");
                return;
            }

            showSuccessToast("Slots updated successfully!");
            setShowSettingsModal(false);
            fetchData();

        } catch (error) {
            showErrorToast(error.message || "Connection Error!");
        }
    };
    const handleSlotCountUpdate = (timeSlot, count) => {
        setSettingsData(prev => ({
            ...prev,
            slots: prev.slots.map(s =>
                s.timeSlot === timeSlot ? { ...s, slotCount: Number(count) } : s
            )
        }));
    };

    const handleSavePrice = async () => {
        try {
            const payload = {
                id: priceData.id,
                serviceFee: Number(priceData.amount)
            };

            const res = await makeRequestAuth(
                "post",
                "/admin/serviceFeeSetup",
                payload
            );

            if (res?.error) {
                showErrorToast(res.message || "Failed to update price");
                return;
            }

            showSuccessToast("Service price updated successfully!");
            setShowPriceModal(false);
            fetchData();
        } catch (error) {
            showErrorToast("Connection Error!");
        }
    };

    return (
        <div className="p-4 md:p-8 bg-[#F8FAFC] min-h-screen font-sans selection:bg-[#24ADD7]/20">
            <ToastContainer />
            <div className="max-w-7xl mx-auto mb-8">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
                    <div className="flex items-center gap-4">
                        <button
                            onClick={() => navigate(-1)}
                            className="p-2.5 bg-white border border-slate-200 rounded-lg text-slate-600 hover:bg-slate-50 transition-all"
                        >
                            <FaArrowLeft />
                        </button>
                        <div>
                            <h2 className="text-2xl font-bold text-slate-900 tracking-tight">Service Settings</h2>
                            <p className="text-slate-500 text-sm">Manage slots and pricing</p>
                        </div>
                    </div>

                    <div className="relative w-full md:w-[320px]">
                        <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                        <input
                            type="text"
                            placeholder="Search service..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="w-full pl-10 pr-4 py-2.5 bg-white border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#24ADD7] focus:border-transparent outline-none text-sm transition-all"
                        />
                    </div>
                </div>
            </div>

            {/* --- LOADER --- */}
            {loading ? (
                <div className="flex flex-col items-center justify-center h-[50vh]">
                    <div className="w-14 h-14 border-[5px] border-slate-200 border-t-[#24ADD7] rounded-full animate-spin shadow-lg"></div>
                    <span className="mt-4 font-bold text-slate-400 animate-pulse">Synchronizing Data...</span>
                </div>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 max-w-7xl mx-auto">
                    {services.map((service) => (
                        <div key={service._id} className="group bg-white rounded-xl overflow-hidden border border-slate-200 hover:border-[#24ADD7]/50 transition-all duration-300 relative shadow-sm">

                            {/* FLOATING ACTIONS */}
                            <div className="absolute top-5 inset-x-5 flex justify-between z-20 pointer-events-none">
                                <button
                                    onClick={() => { setShowPriceModal(true); setPriceData({ id: service._id, amount: service.price || "", name: service.name }); }}
                                    className="pointer-events-auto p-3.5 bg-white/80 backdrop-blur-xl rounded-2xl text-[#24ADD7] shadow-lg opacity-0 -translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 hover:bg-[#24ADD7] hover:text-white"
                                >
                                    <FaWallet className="text-lg" />
                                </button>
                                <button
                                    onClick={() => {
                                        setShowSettingsModal(true);
                                        const serviceSlots = Array.isArray(service.slots) ? service.slots : [];
                                        const serviceSlotNames = serviceSlots.map(s => s.timeSlot);
                                        const merged = Array.from(new Set([...timeSlotsList, ...serviceSlotNames]));
                                        setAllSlots(merged);
                                        setSettingsData({ id: service._id, name: service.name, slots: serviceSlots });
                                    }}
                                    className="pointer-events-auto p-3.5 bg-white/80 backdrop-blur-xl rounded-2xl text-slate-700 shadow-lg opacity-0 -translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 delay-75 hover:bg-[#24ADD7] hover:text-white"
                                >
                                    <FaCog className="text-lg" />
                                </button>
                            </div>

                            {/* IMAGE SECTION */}
                            <div className="h-56 overflow-hidden relative">
                                <img src={service.image} alt={service.name} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700 ease-out" />
                                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-transparent to-transparent opacity-60"></div>
                                <div className="absolute bottom-4 left-6">
                                    <span className={`flex items-center gap-1.5 px-3 py-1 rounded-lg text-[10px] font-black uppercase tracking-widest backdrop-blur-md ${!service.isDisable ? 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/30' : 'bg-rose-500/20 text-rose-400 border border-rose-500/30'}`}>
                                        <span className={`w-1.5 h-1.5 rounded-full animate-pulse ${!service.isDisable ? 'bg-emerald-400' : 'bg-rose-400'}`}></span>
                                        {!service.isDisable ? 'System Active' : 'Offline'}
                                    </span>
                                </div>
                            </div>

                            {/* CONTENT SECTION */}
                            <div className="p-7">
                                <h3 className="text-xl font-extrabold text-slate-800 line-clamp-1 mb-1">{service.name}</h3>
                                <div className="flex items-end justify-between">
                                    <div className="space-y-0.5">
                                        <p className="text-[10px] font-bold text-slate-400 uppercase tracking-tighter">Premium Rate</p>
                                        <div className="flex items-baseline gap-1">
                                            <span className="text-sm font-bold text-[#24ADD7]">₹</span>
                                            <span className="text-3xl font-[1000] text-slate-900 leading-none">{service.serviceFee || '0'}</span>
                                        </div>
                                    </div>
                                    <div className="flex -space-x-2">
                                        {[1, 2, 3].map(i => <div key={i} className="w-7 h-7 rounded-full border-2 border-white bg-slate-100"></div>)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )
            }

            {/* --- MULTI-SELECT SETTINGS MODAL --- */}
            {
                showSettingsModal && (
                    <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-md flex items-center justify-center z-[110] p-4">
                        <div className="bg-white rounded-[3rem] p-8 w-full max-w-3xl shadow-2xl animate-in zoom-in duration-300">
                            <div className="flex justify-between items-start mb-6 border-b border-slate-50 pb-5">
                                <div className="flex items-center gap-5">
                                    <div className="w-14 h-14 bg-[#24ADD7]/10 rounded-2xl flex items-center justify-center text-[#24ADD7] text-2xl">
                                        <FaClock />
                                    </div>
                                    <div>
                                        <h3 className="text-2xl font-black text-slate-900">Configure Availability</h3>
                                        <p className="text-slate-400 font-medium">Manage multi-slots for <span className="text-slate-900">{settingsData.name}</span></p>
                                    </div>
                                </div>
                                <button onClick={() => setShowSettingsModal(false)} className="p-2 hover:bg-slate-100 rounded-full transition-colors text-slate-400"><FaTimes /></button>
                            </div>

                            {/* ➕ ADD CUSTOM TIME SLOT */}
                            <div className="mb-6 flex gap-3">
                                <input
                                    type="text"
                                    placeholder="Add custom slot (e.g. 8:00 PM to 10:00 PM)..."
                                    value={newSlotText}
                                    onChange={(e) => setNewSlotText(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            handleAddCustomSlot();
                                        }
                                    }}
                                    className="flex-1 px-4 py-2.5 rounded-xl border border-slate-200 text-sm focus:border-[#24ADD7] outline-none"
                                />
                                <button
                                    type="button"
                                    onClick={handleAddCustomSlot}
                                    className="px-5 py-2.5 bg-[#24ADD7] hover:bg-[#106D87] text-white text-sm font-bold rounded-xl flex items-center gap-2 transition-all shadow-md shadow-[#24ADD7]/20"
                                >
                                    <FaPlus className="text-xs" /> Add Slot
                                </button>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-[48vh] overflow-y-auto pr-3 custom-scrollbar">
                                {allSlots.map((slot) => {
                                    // Check if slot is currently selected in array
                                    const selectedObj = (Array.isArray(settingsData.slots) ? settingsData.slots : []).find(s => s.timeSlot === slot);
                                    const isSelected = !!selectedObj;
                                    const isEditing = editingSlot?.oldText === slot;

                                    return (
                                        <div
                                            key={slot}
                                            onClick={() => !isEditing && toggleSlotSelection(slot)}
                                            className={`p-3.5 rounded-[1.5rem] border-2 cursor-pointer transition-all duration-300 flex items-center justify-between group ${isSelected
                                                ? 'border-[#24ADD7] bg-[#24ADD7]/5 shadow-sm'
                                                : 'border-slate-100 bg-slate-50 hover:border-slate-200'
                                                }`}
                                        >
                                            {isEditing ? (
                                                <div className="flex items-center gap-2 w-full" onClick={(e) => e.stopPropagation()}>
                                                    <input
                                                        type="text"
                                                        value={editingSlot.newText}
                                                        onChange={(e) => setEditingSlot({ ...editingSlot, newText: e.target.value })}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                e.preventDefault();
                                                                handleSaveEdit();
                                                            }
                                                        }}
                                                        autoFocus
                                                        className="flex-1 px-2.5 py-1 text-sm font-bold bg-white border border-[#24ADD7] rounded-lg outline-none"
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={handleSaveEdit}
                                                        className="p-2 bg-emerald-500 text-white rounded-lg hover:bg-emerald-600 transition-colors"
                                                        title="Save Slot"
                                                    >
                                                        <FaCheck className="text-xs" />
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => setEditingSlot(null)}
                                                        className="p-2 bg-slate-200 text-slate-600 rounded-lg hover:bg-slate-300 transition-colors"
                                                        title="Cancel"
                                                    >
                                                        <FaTimes className="text-xs" />
                                                    </button>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="flex items-center gap-3 min-w-0 flex-1">
                                                        <div className={`w-5 h-5 rounded-md border-2 flex-shrink-0 flex items-center justify-center transition-all ${isSelected ? 'bg-[#24ADD7] border-[#24ADD7]' : 'bg-white border-slate-200'}`}>
                                                            {isSelected && <FaCheck className="text-white text-[9px]" />}
                                                        </div>
                                                        <span className={`text-xs md:text-sm font-bold truncate ${isSelected ? 'text-slate-900' : 'text-slate-600'}`}>{slot}</span>
                                                    </div>

                                                    <div className="flex items-center gap-2 flex-shrink-0" onClick={(e) => e.stopPropagation()}>
                                                        {isSelected && (
                                                            <div className="bg-white px-2 py-1 rounded-lg border border-[#24ADD7]/30 flex items-center gap-1.5 shadow-sm">
                                                                <span className="text-[9px] font-black text-slate-400 uppercase">Limit:</span>
                                                                <input
                                                                    type="number"
                                                                    min="1"
                                                                    value={selectedObj.slotCount}
                                                                    onChange={(e) => handleSlotCountUpdate(slot, e.target.value)}
                                                                    className="w-8 text-center font-black text-xs text-[#24ADD7] outline-none bg-transparent"
                                                                />
                                                            </div>
                                                        )}

                                                        {/* EDIT BUTTON */}
                                                        <button
                                                            type="button"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setEditingSlot({ oldText: slot, newText: slot });
                                                            }}
                                                            className="p-1.5 text-slate-400 hover:text-[#24ADD7] hover:bg-white rounded-md transition-all"
                                                            title="Edit Slot Name"
                                                        >
                                                            <FaEdit className="text-xs" />
                                                        </button>

                                                        {/* DELETE BUTTON */}
                                                        <button
                                                            type="button"
                                                            onClick={(e) => handleDeleteSlot(e, slot)}
                                                            className="p-1.5 text-slate-400 hover:text-rose-500 hover:bg-rose-50 rounded-md transition-all"
                                                            title="Delete Slot"
                                                        >
                                                            <FaTrash className="text-xs" />
                                                        </button>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="flex items-center gap-4 mt-8 pt-6 border-t border-slate-50">
                                <button onClick={() => setShowSettingsModal(false)} className="px-6 py-4 font-bold text-slate-400 hover:text-slate-600 transition-colors">Dismiss</button>
                                <button
                                    onClick={handleSaveSettings}
                                    className="flex-1 py-4 bg-[#24ADD7] text-white font-bold rounded-2xl shadow-xl shadow-[#97E2F7] hover:bg-[#106D87] transition-all flex items-center justify-center gap-3 group"
                                >
                                    Apply {Array.isArray(settingsData.slots) ? settingsData.slots.length : 0} Slots
                                    <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }

            {/* --- PRICE MODAL --- */}
            {
                showPriceModal && (
                    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-xl flex items-center justify-center z-[120] p-4">
                        <div className="bg-white rounded-[3rem] p-10 w-full max-w-[440px] shadow-[0_30px_100px_-20px_rgba(0,0,0,0.3)] animate-in slide-in-from-top-10 duration-500">
                            <div className="flex flex-col items-center mb-8">
                                <div className="w-20 h-20 bg-emerald-50 text-emerald-500 rounded-3xl flex items-center justify-center text-4xl mb-4 transform rotate-6">
                                    <HiOutlineCurrencyRupee />
                                </div>
                                <h3 className="text-2xl font-black text-slate-900">Adjust Rate</h3>
                                <p className="text-slate-400 text-center mt-1">Update the market value for<br /><span className="text-slate-900 font-bold">{priceData.name}</span></p>
                            </div>

                            <div className="relative mb-8 group">
                                <div className="absolute inset-y-0 left-6 flex items-center pointer-events-none">
                                    <span className="text-2xl font-black text-slate-300 group-focus-within:text-[#24ADD7]">₹</span>
                                </div>
                                <input
                                    type="number"
                                    value={priceData.amount}
                                    onChange={(e) => setPriceData({ ...priceData, amount: e.target.value })}
                                    className="w-full bg-slate-50 border-2 border-slate-100 focus:border-[#24ADD7] focus:bg-white pl-12 pr-8 py-6 rounded-2xl outline-none text-4xl font-black text-slate-900 transition-all shadow-inner"
                                    placeholder="00"
                                    autoFocus
                                />
                            </div>

                            <div className="flex gap-4">
                                <button onClick={() => setShowPriceModal(false)} className="flex-1 py-4 font-bold text-slate-400">Cancel</button>
                                <button onClick={handleSavePrice} className="flex-[2] py-4 bg-[#24ADD7] text-white font-bold rounded-2xl shadow-lg shadow-[#106D87] hover:scale-[1.02] transition-all">Confirm Update</button>
                            </div>
                        </div>
                    </div>
                )
            }
            
            <style jsx>{`
                .custom-scrollbar::-webkit-scrollbar { width: 4px; }
                .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
                .custom-scrollbar::-webkit-scrollbar-thumb { background: #E2E8F0; border-radius: 10px; }
                .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #CBD5E1; }
            `}</style>
        </div >
    );
}